import { render, staticRenderFns } from "./Report-14-pdf.vue?vue&type=template&id=470c220c&scoped=true"
import script from "./Report-14-pdf.vue?vue&type=script&lang=js"
export * from "./Report-14-pdf.vue?vue&type=script&lang=js"
import style0 from "./Report-14-pdf.vue?vue&type=style&index=0&id=470c220c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470c220c",
  null
  
)

export default component.exports